import React from 'react';
import { Redirect } from 'react-router-dom';
import { alfrescoRoles } from '../constants';
import { DocumentsRegisterRoutes } from './DocumentsRegisterRoutes';
export function MainPage(props) {
    if (JSON.parse(localStorage.getItem("user")).role === alfrescoRoles.PORTAL_ADMINISTRATOR) return (<Redirect to="/admin" />);
    return (<DocumentsRegisterRoutes />);
}